import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/seasons-50k-badge.png")